/* eslint-disable import/prefer-default-export */
export enum PlanState {
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED'
}
